import { ReactNode } from "react";

/**
 * LegendItemComponent
 */

type Props = {
  icon: ReactNode,
  label: string,
};

export const LegendItemComponent = ({
  icon,
  label,
}: Props) => {
  return (
    <div className="flex flex-row items-center gap-1">
      {icon}
      <span className="text-[.75rem] text-black dark:text-white">{label}</span>
    </div>
  );
}